module.exports = __webpack_public_path__ + "static/media/bonus_receive.8fd2ee8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/nyf/mp3/bonus_receive.mp3
// module id = KQP3
// module chunks = 1 12